/* eslint-disable */
import {
  assertNumber,
  attachSingleReferenceComponent,
  attributeSelectionComponent,
  childEntitySelectionComponent,
  composedOfComponent,
  memoEval,
  priceComponent,
  referenceComponent,
  violationsComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'
import { Base, BaseTypes, Bench, SeatingTypes, SheenTypes, Top, WoodSpecies } from '../model/index.js'

export const tableComponents = [
  attachSingleReferenceComponent(
    attachComponent.withComponent(referenceComponent, 'Table.$top', true).withEntity('Table'),
    Top,
    'topId'
  ),

  attachComponent
    .withComponent(composedOfComponent, '$top', true)
    .withEntity('Table')
    .attach(
      memoEval(
        self => [self.$top?.id ?? null],
        id => ({ childEntityIds: id === null ? [] : [id] })
      )
    ),

  attachSingleReferenceComponent(
    attachComponent.withComponent(referenceComponent, 'Table.$base', true).withEntity('Table'),
    Base,
    'baseStyleId'
  ),

  attachComponent
    .withComponent(composedOfComponent, '$base', true)
    .withEntity('Table')
    .attach(
      memoEval(
        self => [self.$base?.id ?? null],
        id => ({ childEntityIds: id === null ? [] : [id] })
      )
    ),

  attachSingleReferenceComponent(
    attachComponent.withComponent(referenceComponent, 'Table.$bench', true).withEntity('Table'),
    Bench,
    'benchId'
  ),

  attachComponent
    .withComponent(composedOfComponent, '$bench', true)
    .withEntity('Table')
    .attach(
      memoEval(
        self => [self.$bench?.id ?? null],
        id => ({ childEntityIds: id === null ? [] : [id] })
      )
    ),

  attachComponent
    .withComponent(priceComponent, 'usd', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$price],
        $price => ({
          price: $price,
          currency: 'USD',
        })
      )
    ),

  attachComponent
    .withComponent(childEntitySelectionComponent, 'tops', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.topId, self.$topOptions],
        (topId, $topOptions) => ({
          value: topId,
          options: $topOptions,
        })
      )
    ),

  attachComponent
    .withComponent(childEntitySelectionComponent, 'baseStyles', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.baseStyleId, self.$baseStyleOptions],
        (baseStyleId, $baseStyleOptions) => ({
          value: baseStyleId,
          options: $baseStyleOptions,
        })
      )
    ),

  attachComponent
    .withComponent(attributeSelectionComponent, 'baseTypes', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.baseType],
        baseType => ({
          value: baseType,
          options: [
            {
              label: 'Pedestal',
              value: 'Pedestal',
              img: '/images/legs/tuscan.png',
            },
            {
              label: 'Metal',
              value: 'Metal',
              img: '/images/legs/triflection.png',
            },
            {
              label: 'Four Leg',
              value: 'FourLeg',
              img: '/images/legs/old-english-turned.png',
            },
          ],
        })
      ),
      state => {
        BaseTypes.assert(state.value)
        return { baseType: state.value }
      }
    ),

  attachComponent
    .withComponent(attributeSelectionComponent, 'woodSpecies', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.woodSpecies],
        woodSpecies => ({
          value: woodSpecies,
          options: [
            {
              label: 'Hickory',
              value: 'Hickory',
              img: '/textures/hickory3/hickory_BaseColor.jpg',
            },
            {
              label: 'Ash',
              value: 'Ash',
              img: '/textures/oak/oak_BaseColor.jpg',
            },
            {
              label: 'Maple',
              value: 'Maple',
              img: '/textures/maple/maple_BaseColor.jpg',
            },
            {
              label: 'Walnut',
              value: 'Walnut',
              img: '/textures/walnut2/walnut_BaseColor.jpg',
            },
            {
              label: 'Rift/Qtr. White Oak',
              value: 'QuarterSawnWhiteOak',
              img: '/textures/oak4/oak_BaseColor.jpg',
            },
          ],
        })
      ),
      state => {
        WoodSpecies.assert(state.value)
        return { woodSpecies: state.value }
      }
    ),

  attachComponent
    .withComponent(attributeSelectionComponent, 'sheens', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.sheen],
        sheen => ({
          value: sheen,
          options: [
            {
              label: 'Flat',
              value: 'Flat',
            },
            {
              label: 'Satin',
              value: 'Satin',
            },
          ],
        })
      ),
      state => {
        SheenTypes.assert(state.value)
        return { sheen: state.value }
      }
    ),

  attachComponent
    .withComponent(attributeSelectionComponent, 'seatingType', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.seatingType],
        seatingType => ({
          value: seatingType,
          options: [
            {
              label: 'No Seating',
              value: 'NoSeating',
            },
            {
              label: 'Benches',
              value: 'Benches',
            },
            {
              label: 'Chairs',
              value: 'Chairs',
            },
            {
              label: 'Chairs and Benches',
              value: 'ChairsAndBenches',
            },
          ],
        })
      ),
      state => {
        SeatingTypes.assert(state.value)
        return { seatingType: state.value }
      }
    ),

  attachComponent
    .withComponent(attributeSelectionComponent, 'seatingAmount', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.seatingAmount, self.$seatingAmountOptions],
        (seatingAmount, $seatingAmountOptions) => ({
          value: seatingAmount,
          options: $seatingAmountOptions,
        })
      ),
      state => {
        assertNumber(state.value)
        return { seatingAmount: state.value }
      }
    ),

  attachComponent
    .withComponent(violationsComponent, 'default', true)
    .withEntity('Table')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$violations],
        $violations => ({
          violations: $violations,
        })
      )
    ),
]
